/**
 * @module
 * @description Enumeration for person options update properties.
 * These values are used by the API to identify which options are being updated.
 */

const UpdatePersonOptionsProp = {
  UNSPECIFIED: 0,
  ENROLMENT_APPLICATIONS_CUSTOM_FIELDS: 1,
  DATACARDS_ASSESSMENT_IDS: 2,
  DATACARDS_ASSESSMENT_MODULE_IDS: 3,
  DATACARDS_SUBJECT_IDS: 4,
  DATACARDS_PROGRESS_IDS: 5,
  DEFAULT_MILESTONE_SET: 6,
  AUTOSAVE_NUMERIC_GRADES: 7,
  HIDE_ARCHIVED_LINE_ITEMS: 8,
  HAS_ACKNOWLEDGED_REPORT_DISCLAIMER: 9,
  PROGRESS_OVERVIEW_MODE: 10,
  PROGRESS_OVERVIEW_YEAR: 11,
  PROGRESS_OVERVIEW_CONTROLS_MINIMISED: 12,

  /**
   * Gets the label for a given update prop value
   * @param value - The enum value
   * @return The human-readable label
   */
  getLabel(value: number): string {
    switch (value) {
      case this.UNSPECIFIED:
        return 'Unspecified';
      case this.ENROLMENT_APPLICATIONS_CUSTOM_FIELDS:
        return 'Enrolment Applications Custom Fields';
      case this.DATACARDS_ASSESSMENT_IDS:
        return 'Datacards Assessment IDs';
      case this.DATACARDS_ASSESSMENT_MODULE_IDS:
        return 'Datacards Assessment Module IDs';
      case this.DATACARDS_SUBJECT_IDS:
        return 'Datacards Subject IDs';
      case this.DATACARDS_PROGRESS_IDS:
        return 'Datacards Progress IDs';
      case this.DEFAULT_MILESTONE_SET:
        return 'Default Milestone Set';
      case this.AUTOSAVE_NUMERIC_GRADES:
        return 'Autosave Numeric Grades';
      case this.HIDE_ARCHIVED_LINE_ITEMS:
        return 'Hide Archived Line Items';
      case this.HAS_ACKNOWLEDGED_REPORT_DISCLAIMER:
        return 'Has Acknowledged Report Disclaimer';
      case this.PROGRESS_OVERVIEW_MODE:
        return 'Progress Overview Mode';
      case this.PROGRESS_OVERVIEW_YEAR:
        return 'Progress Overview Year';
      case this.PROGRESS_OVERVIEW_CONTROLS_MINIMISED:
        return 'Progress Overview Controls Minimised';
      default:
        return 'Unknown';
    }
  },
} as const;

export default UpdatePersonOptionsProp;
